import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postDiscounts = async ({ serviceId, discounts }: JsonDataItem) => {
  const { data } = await baseQuery('job-discount', {
    type: 'POST',
    body: {
      service_id: serviceId,
      discounts,
    },
  });

  return data;
};
